var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-primary md-info",on:{"click":_vm.clickFunc}},[_c('div',{staticStyle:{"margin":"0 -8px 0 -18px","display":"flex","line-height":"18px"}},[_c('md-icon',[_vm._v("add")]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }